import template from './form.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import procesosBatchI18N from 'i18n/procesos-batch/es.json';
import commonI18N from 'i18n/common/es.json';
import { formatErrorMessage } from 'core/util';


export let ProcesoBatchFormComponent = {
  templateUrl: template,
  selector: 'procesoBatchForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(procesosBatchI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', '$scope'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, $scope) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.cancel = cancel.bind(this);

  let unsubscribe;
  const valoresFilter = Filter.path('tipo.codigo').eq('estado_activacion');

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    ngNotify.dismiss();
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver proceso de batch'] : this.translations['Editar proceso de batch'];
      this.formEdit('procesos-batch', $stateParams.uid);
    } else {
      this.title = this.translations['Nueva proceso de batch'];
      this.form();
    }
    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;

    this.model = state.form.model;

    if (!this.model.id && state.valores.data && state.valores.data.length > 0) {
      this.model.estado = state.valores.data.filter(v => v.value === 'Activo')[0];
    }

    return {
      form: state.form,
      estados: state.valores.data
    };
  }

  function cancel() {
    $state.go('home.procesos-batch.list');
  }


  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.procesos-batch.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.procesos-batch.list');
    }
  }

  function doSubmit() {
    if ($scope.form.$invalid) {
      this.submitted = true;
      return;
    }
    let data = Object.assign({}, this.model);
    this.save('procesos-batch', data);
  }
}


// WEBPACK FOOTER //
// ./src/components/procesos-batch/form/form.component.js